import React from "react"
import get from "lodash/get"

import PageHeader from "../PageHeader"
import HowBid from "../HowBid"
import i18n from "../../i18n"
import Cookie from "../../util/Cookie"

const HowBidWorks = (props) => {
  const locale = Cookie.get("X-Reycreo-Language-Id")
  i18n.changeLanguage(locale || "en")
  console.log(" CHecking HBW :: ", locale)

  return (
    <div className='container'>
      <PageHeader
        backLocation={`/play/product-details/${get(
          props,
          "location.state.title"
        )}/${get(props, "location.state.offerId")}`}
        label={i18n.t("HowBidWork")}
      />
      <div className='container_body'>
        <HowBid />
      </div>
    </div>
  )
}

export default HowBidWorks



// WEBPACK FOOTER //
// ./src/views/HowBidWorks/index.js